import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {LocalStorage} from 'ngx-store';

@Injectable()
export class SessionService {
    api: string = environment.apiUrl;
    @LocalStorage('loggedUser') loggedUser: any;
    @LocalStorage('userData') userData: any;

    constructor(private http: HttpClient) {}

    async addSession(data): Promise<any> {
        const sessionId = this.userData.session_id;
        const headers = new HttpHeaders({'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token});
        return await this.http
            .put(this.api + `/users/session/${sessionId}`, data, {headers, observe: 'response'})
            .toPromise();
    }
    async actualExp(): Promise<any> {
        const headers = new HttpHeaders({'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token});
        return await this.http
            .get(this.api + `/user/actualExp`, {headers, observe: 'response'})
            .toPromise();
    }
}
